module.exports = __webpack_public_path__ + "media/images/lb/130-d296fa73fa3978582a8c468b26b384e8.svg";